import 'core-js';
import ResizeObserver from 'resize-observer-polyfill';

global.ResizeObserver ??= ResizeObserver;
if (typeof HTMLElement.prototype.getRootNode === 'undefined')
  HTMLElement.prototype.getRootNode = function () {
    return document;
  };
